import React from 'react';
import Home from './Pages/Home';

function App() {
  console.log("App component rendered");
  return (
    <div className="App">
      <Home />
      
    </div>
  );
}

export default App;
